export class UserAlertNotificationSettings {
  id: string;
  userId: string;
  serviceId: string;
  email: boolean;
  sms: boolean;
}
